<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Empresas
    v-layout(align-start='', justify-start='', row='', fill-height='')
        v-flex(xs12)
            v-card(color='', style="border-radius:5px;background-color: black;height:80px")
                v-card-title.justify-center
                    img(src='../assets/logo3.png', with='50' ,height='50')
            v-card(color='', style="border-radius:5px;background-color: #d6d6d6")
                v-card-title(style="padding: 7px;").justify-center
                    span.black--text  Dashboard
    v-flex(xs12 sm12 md12 style='margin-top:40px;text-align:center;')
      h2 Período: {{fechaI | moment('DD/MM/YYYY')}} - {{settings.expire | moment('DD/MM/YYYY')}}
    v-flex(xs12 sm12 md12 style='margin-top:40px;')
      v-layout(wrap align-center justify-center)
        v-flex(xs12 sm6 style='padding: 10px;')
          v-card(style='border-radius: 10px;')
            div(style='text-align:center;background: black;border-radius: 10px 10px 0px 0px;')
              span(style='font-size: 35px;color:white;') Total
            div(style='text-align:center;')
              span(style='font-size: 45px;') {{settings.credits}}
        v-flex(xs12 sm6 style='padding: 10px;')
          v-card(style='border-radius: 10px;')
            div(style='text-align:center;background: black;border-radius: 10px 10px 0px 0px;')
              span(style='font-size: 35px;color:white;') Empresas
            div(style='text-align:center;')
              span(style='font-size: 45px;') {{mensajes}}
                        

</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "mDashboard",
  data: () => ({
    ruta: server + ":" + port,
    fechaI: null,
    mensajes: 0,
    settings: {}
  }),
  sockets: {
    SMS() {
      this.obtSMS();
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    obtSMS() {
      Api.get("empresa/mensajes").then(res => {
        this.mensajes = res.data;
      });
    },
    initialize() {
      Api.get("empresa/mensajes").then(res => {
        this.mensajes = res.data;
      });
      Api.get("settings/saldo").then(res => {
        this.settings = res.data;
        this.settings.expire = this.$moment(this.settings.expire).format("DD/MM/YYYY");
        this.fechaI = this.$moment(this.settings.expire).subtract(1, "months");
      });
      // Api.get("settings").then(res => {
      //   if (res.data[0]) {
      //     this.settings = res.data[0];
      //     this.settings.fechaCorte = this.$moment(this.settings.fechaCorte).add(
      //       4,
      //       "h"
      //     );
      //     if (this.settings.first) {
      //       this.fechaI = this.$moment(this.settings.fechaCorte).subtract(1, "months");
      //     } else {
      //       this.fechaI = this.$moment(this.settings.fechaCorte).add(1, "d").subtract(1, "months");
      //     }
      //   }
      // });
    }
  }
};
</script>
